import { useRef } from "react";
import Slider from "react-slick";
import { Stack, Typography, useTheme } from "@mui/material";

import { useResponsive } from "@app/hooks";
import { Strings } from "@app/constants";
import { testimonial } from "./testimonialData";
import { TestimonialCard } from "./testimonialCard";

const Testimonial = () => {
  const theme = useTheme();
  const data = testimonial;
  const slideRef = useRef<Slider>(null);
  const isMobile = useResponsive("down", "sm");

  const settings = {
    dots: isMobile ? false : true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    variableWidth: false,
    adaptiveHeight: true,
  };

  return (
    <Stack
      sx={{
        pt: 3,
        pb: 10,
      }}
    >
      <Stack
        sx={{
          width: "100%",
          pb: 3,
        }}
      >
        <Typography variant="h3" textAlign={"center"}>
          {Strings.testimonial.whatOurClientSay}
        </Typography>
      </Stack>
      <Stack
        sx={{
          width: { xs: "90%", md: "70%" },
          alignSelf: "center",
          backgroundColor: theme.palette.grey[200],
          p: { xs: 2, sm: 4 },
          position: "relative",
          overflow: "visible",
          "& .slick-slider": {
            overflow: "visible",
          },
          "& .slick-track": {
            display: "flex",
            alignItems: "stretch",
          },
          "& .slick-slide": {
            height: "auto",
            "& > div": {
              height: "100%",
            },
          },
          "& .slick-dots": {
            width: "fit-content",
            bottom: "unset",
            position: "absolute",
            top: "50%",
            right: -20,
            transform: "translateY(-50%)",
            display: "flex !important",
            flexDirection: "column !important",
            justifyContent: "center",
            alignItems: "center",
            gap: "8px",
            height: "auto",
            "& li": {
              margin: 0,
              width: "auto !important",
              height: "auto !important",
              display: "block !important",
            },
            "& li button": {
              padding: 0,
            },
            "& li button:before": {
              color: theme.palette.common.black,
              fontSize: "12px",
            },
            "& li.slick-active button:before": {
              color: theme.palette.primary.main,
              opacity: 1,
            },
          },
        }}
      >
        <Slider ref={slideRef} {...settings}>
          {data?.map((item, index) => (
            <TestimonialCard
              key={index}
              name={item.name}
              position={item.position}
              rating={item.rating}
              testimonial={item.testimonial}
              onNext={() => slideRef?.current?.slickNext()}
              onPrev={() => slideRef?.current?.slickPrev()}
            />
          ))}
        </Slider>
      </Stack>
    </Stack>
  );
};

export { Testimonial };
